import React from 'react';
import {PropTypes} from 'prop-types';
import {PropTypesEx} from '../../shared/proptypes.extensions';
import {Checkbox} from '../../shared/checkbox';
import {ButtonBusyIndicatorComponent} from '../../shared/buttonBusyIndicatorComponent';
import {DisplayErrors, AssignProperties, PreventDOMLock} from '../../shared/utils';

import './styles.scss';

const EMAILSUBSCRIPTION_ACTION = {
    NONE: 0,
    DISABLEALL: 2,
    ENABLEALL: 3
}

export class EmailSubscriptionsComponent extends React.Component{
    constructor(props, ...others) {
        super(props, ...others);
        this.strings = {...this.constructor.defaultProps.strings};
        AssignProperties(this.strings, props.strings);

        this.state = {
            action: EMAILSUBSCRIPTION_ACTION.NONE,
            changedEmailTypes: []
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleEnableAllClick = this.handleEnableAllClick.bind(this);
        this.handleDisableAllClick = this.handleDisableAllClick.bind(this);
        this.doSave = this.doSave.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleChange(e) {
        const mailTypeId = parseInt(e.target.getAttribute('data-id'));

        if (!isNaN(mailTypeId)) {
            const self = this;
            const value = e.target.checked;

            PreventDOMLock(() => self.doSave(mailTypeId, !value));
        }
    }

    handleEnableAllClick() {
        const self = this;

        PreventDOMLock(() => self.doSave(null, false));
    }

    handleDisableAllClick() {
        const self = this;
        
        PreventDOMLock(() => self.doSave(null, true));
    }

    doSave(mailTypeId, isUnsubscribed) {
        const self = this;
        let resetState = false;

        new Promise((resolve, reject) => {
            if (self._isMounted && ((mailTypeId == null) || !self.state.changedEmailTypes.some(id => id == mailTypeId))) {
                resetState = true;
                const newState = {
                    changedEmailTypes: [...self.state.changedEmailTypes, mailTypeId]
                }
    
                if ((mailTypeId == null) && isUnsubscribed) {
                    newState.action = EMAILSUBSCRIPTION_ACTION.DISABLEALL;
                }
                else if ((mailTypeId == null) && !isUnsubscribed) {
                    newState.action = EMAILSUBSCRIPTION_ACTION.ENABLEALL;
                }

                self.setState(newState, resolve);
            }
            else {
                reject(null);
            }
        })
        .then(() => {
            if (self._isMounted) {
                return self.props.doSaveMailSubscription(mailTypeId, isUnsubscribed);
            }
        })
        .catch(errors => {
            if (self._isMounted && (errors != null)) {
                DisplayErrors(errors);
            }
        })
        .then(p => {
            if (self._isMounted && resetState) {
                const changedEmailTypes = self.state.changedEmailTypes.filter(id => id != mailTypeId);

                self.setState({action: EMAILSUBSCRIPTION_ACTION.NONE, changedEmailTypes: changedEmailTypes});
            }
        });
    }

    render() {
        const self = this;
        const {disabled, subscriptions, usedMailTypes, doSaveMailSubscription, readOnly, id} = self.props;
        const {action, changedEmailTypes} = self.state;
        const isDisabled = disabled || (typeof doSaveMailSubscription !== 'function') || (action != EMAILSUBSCRIPTION_ACTION.NONE) || readOnly;
        const strings = self.strings;

        let firstColCount = Math.ceil(subscriptions.length / 2);

        const _renderItem = item => {
            const isBusy = changedEmailTypes.some(id => id == item.MailTypeId);
            const mailTypesDefined = (usedMailTypes != null) && (usedMailTypes.length > 0);
            const isEnabled = !mailTypesDefined || usedMailTypes.some(p => p == item.MailTypeId);

            return (
                <Checkbox
                    id={id + `.chk${item.MailTypeId}`}
                    key={item.MailTypeId}
                    disabled={isDisabled || isBusy /*|| !isEnabled*/}
                    checked={!item.IsUnsubscribed} 
                    data-id={item.MailTypeId}
                    // indeterminate={!isEnabled}
                    onChange={self.handleChange}
                    className={mailTypesDefined ? (isEnabled ? 'font-weight-semibold' : 'ico-muted') : undefined}
                    label={
                        <>
                            <span className={`item-name mr-1 sh-${item.StrId.toLowerCase()}-notification`}>{item.MailTypeName}</span>
                            <i className={'fa fa-sun-o fa-spin' + (isBusy ? '' : ' invisible')} />
                        </>
                    }
                />
            )
        }

        return (
            <div className="email-subscriptions" id={id}>
                {!Boolean(readOnly) &&
                    <div className="form-buttons">
                        <button 
                            type="button" 
                            className="btn btn-outline-success btn-sm newstyle sh-enable-all-notifications" 
                            onClick={self.handleEnableAllClick}
                            disabled={isDisabled || (changedEmailTypes.length > 0) || !subscriptions.some(p => p.IsUnsubscribed)}
                        >
                            {strings.BTN_EnableAll}
                            <ButtonBusyIndicatorComponent visible={action == EMAILSUBSCRIPTION_ACTION.ENABLEALL} />
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-outline-danger btn-sm newstyle sh-disable-all-notifications" 
                            onClick={self.handleDisableAllClick}
                            disabled={isDisabled || (changedEmailTypes.length > 0) || !subscriptions.some(p => !p.IsUnsubscribed)}
                        >
                            {strings.BTN_DisableAll}
                            <ButtonBusyIndicatorComponent visible={action == EMAILSUBSCRIPTION_ACTION.DISABLEALL} />
                        </button>
                    </div>
                }
                <div className="d-flex flex-wrap">
                    <div className="pr-3">
                        {subscriptions.filter((p, i) => i < firstColCount).map(_renderItem)}
                    </div>
                    {(firstColCount < subscriptions.length) &&
                        <div className="pr-3">
                            {subscriptions.filter((p, i) => i >= firstColCount).map(_renderItem)}
                        </div>
                    }
                </div>
            </div>
        )
    }
}
EmailSubscriptionsComponent.propTypes = {
    strings: PropTypes.object,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    subscriptions: PropTypes.arrayOf(PropTypes.shape({
        MailTypeId: PropTypes.number.isRequired,
        MailTypeName: PropTypes.string.isRequired,
        StrId: PropTypes.string.isRequired,
        IsUnsubscribed: PropTypes.bool,

    })).isRequired,
    usedMailTypes: PropTypes.arrayOf(PropTypes.number),
    doSaveMailSubscription: PropTypes.func,
    id: PropTypesEx.elementId.isRequired,
}
EmailSubscriptionsComponent.defaultProps = {
    strings: {
        BTN_EnableAll: 'Enable all',
        BTN_DisableAll: 'Disable all',
    },
    disabled: false
}
